import normalizeTransaction from './transaction'

const WON_STATUSES = ['succeeded']
const LOST_STATUSES = ['failed']
const QUALIFIED_STATUSES = ['qualified']
const DISQUALIFIED_STATUSES = ['disqualified']

const questionTypes = {
  single_choice: 'singleChoiceAnswer',
  multiple_choice: 'multipleChoiceAnswer',
  date: 'dateAnswer',
  boolean: 'booleanAnswer',
  free_text: 'freeTextAnswer',
}

const getState = ({ status, appointment }) => {
  if (WON_STATUSES.includes(status)) {
    return 'won'
  }
  if (LOST_STATUSES.includes(status)) {
    return 'lost'
  }
  if (QUALIFIED_STATUSES.includes(status)) {
    if (appointment) {
      const now = new Date().getTime()
      const appointmentDate = new Date(appointment.scheduledAt).getTime()
      if (now < appointmentDate) {
        return 'consultation'
      }
      return 'treatment'
    }

    return 'qualified'
  }
  if (DISQUALIFIED_STATUSES.includes(status)) {
    return 'disqualified'
  }

  return 'new'
}

const normalize = ({
  offers = [],
  productAnswers = [],
  appointment = {},
  ...rest
}) => {
  // Parse product answer values
  const productAnswersMap = productAnswers.reduce((mem, item) => {
    if (item.type === 'multiple_choice') {
      mem[item.id] = {
        value: item[questionTypes[item.type]].Values,
        freeTextValue: item[questionTypes[item.type]].value,
      }
    } else {
      mem[item.id] = (item[questionTypes[item.type]] || {}).value
    }
    return mem
  }, {})

  const lead = {
    ...rest,
    offers: offers.map(o => normalizeTransaction(o)),
    appointment: appointment.uuid ? appointment : null,
    productAnswers: productAnswersMap,
  }

  const state = getState(lead)

  return {
    ...lead,
    merchant: lead?.merchants?.[0],
    state,
  }
}

export default normalize
